<template>
  <el-button type="default" size="small" class="user-display-btn">
    <template v-if="user">
      <div class="userInfo">
        <p class="mb-2">
          <span v-if="String(user.gender) == '0'">آقای </span>
          <span v-if="String(user.gender) == '1'">خانم </span>
          <span v-if="user.firstName">{{ user.firstName + ' ' }}</span>
          <span>{{ user.name }}</span>
        </p>
        <p class="mb-0">{{ user.mobile }}</p>
      </div>
    </template>
    <p v-else class="mb-0">سلام</p>
  </el-button>
</template>

<script>
export default {
  name: 'UserDisplay',
  props: {
    user: { type: [Object, String], default: null },
  },
}
</script>
